import { getFetchUrl } from './get-fetch-url';
/**
 * @internal
 */
export var getFetchEntityUrl = function (entityId, productType, includeType) {
    return getFetchUrl(entityId, productType, includeType);
};
